module.exports = __webpack_public_path__ + "img/normal-selected-2a9e585a.png";